import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import { axiosPost } from "../../../utils/AxiosApi";
import { checkWidgetAdminOrNot, URL } from "../../../utils/Constants";
import { displayErrorMessage } from "../../../utils/Utils";
import GranularPermissionModal from "../../Permissions/GranularPermissionModal";
import ModalWindow from "../../UI/ModalWindow";
import InventoryItemForm from "./InventoryItemForm";

class InventoryItems extends Component {
  state = {
    addModal: false,
    categories: [],
    filterCategoryId: "",
    inventories: [],
    loader: false,
    quantity: 1,
    permissionModal: false,
  };

  componentDidMount() {
    this.getInventories();
    this.getCategories();
  }

  getCategories = () => {
    axiosPost(
      URL.getAllFeeCategory,
      { isInventoryCategory: true },
      (response) => {
        if (response.status === 200) {
          this.setState({ categories: response.data.data });
        }
      }
    );
  };

  getInventories = () => {
    this.setState({ loader: true, inventories: [] }, function () {
      let param = {
        feeCategoryId: this.state.filterCategoryId,
      };
      axiosPost(
        URL.getInventories,
        param,
        (res) => {
          if (res.status === 200) {
            let datum = res.data.data;
            if (datum.length > 0) {
              datum.forEach((el) => {
                el.quantity = 0;
                el.editQuantity = false;
              });
            }
            this.setState({ inventories: datum, loader: false });
          }
        },
        (err) => {
          this.setState({ loader: false });
        }
      );
    });
  };

  handleAddModal = () => {
    this.setState((prevState) => {
      return { ...prevState, addModal: !prevState.addModal };
    });
  };

  handleChange = (e) => {
    let name = e.target.name,
      value = e.target.value;

    // if (name === "quantity" && value <= 0) {
    //   swal("Oops", "Adding number cannot be zero and less than zero");
    //   return false;
    // }

    this.setState({ [name]: value }, () => {
      if (name === "filterCategoryId") {
        this.getInventories();
      }
    });
  };

  // handleEditQuantity = (idx) => {
  //   let inventories = this.state.inventories;
  //   inventories.forEach((el) => {
  //     el.editQuantity = false;
  //   });
  //   inventories[idx].editQuantity = true;
  //   this.setState({ inventories, quantity: 1 });
  // };

  // handleCancelQuantityEdit = (idx) => {
  //   let inventories = this.state.inventories;
  //   inventories[idx].editQuantity = false;
  //   this.setState({ inventories, quantity: 1 });
  // };

  handleChangeEditQuantity = (idx, edit) => {
    let inventories = this.state.inventories;
    inventories.forEach((el) => {
      el.editQuantity = false;
    });

    if (edit) {
      inventories[idx].editQuantity = true;
    }

    this.setState({ inventories, quantity: 1 });
  };

  handleQuantityChange = (e, idx) => {
    const { name, value } = e.target;
    let inventories = [...this.state.inventories];
    inventories[idx][name] = value;
    this.setState({ inventories });
  };

  submitQuantity = (id) => {
    let data = {
      inventoryItemId: id,
      quantity: this.state.quantity,
    };

    if (this.state.quantity < 1) {
      swal("Oops", "Adding quantity cannot be zero and less than zero");
    } else {
      axiosPost(
        URL.insertInventoryQuantity,
        data,
        (res) => {
          if (res.status === 200) {
            swal("Success", "Quantity successfully added");
            this.getInventories();
          }
        },
        (err) => {
          displayErrorMessage(err);
        }
      );
    }
  };

  render() {
    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "81.5vh" }}>
        <div className="tt-group-header">
          Inventory Items
          {checkWidgetAdminOrNot("Account") ? (
            <button
              className="tt-button tt-button-primary float-right permissionBtnCSS"
              onClick={() => {
                this.setState({
                  permissionModal: !this.state.permissionModal,
                });
              }}
            >
              Permissions
            </button>
          ) : null}
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <button
                className="tt-button tt-button-primary"
                onClick={this.handleAddModal}
              >
                Add Inventory Items
              </button>
            </div>
            <div className="col-md-6 text-right">
              <div className="row">
                <div className="col-md-4 mt-1">
                  <strong>Filter By Category</strong>
                </div>
                <div className="col-md-8">
                  <select
                    className="form-control"
                    name="filterCategoryId"
                    value={this.state.filterCategoryId}
                    onChange={this.handleChange}
                    placeholder="Choose Category"
                  >
                    <option value="">All</option>
                    {this.state.categories.map((category, idx) => (
                      <option key={idx} value={category.id}>
                        {category.category}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div>
            <table className="table table-bordered table-striped mt-2">
              <thead className="tt-group-header">
                <tr>
                  <th width="60px" className="text-center">
                    SN
                  </th>
                  <th>Item Name [ Item Code ]</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th></th>
                  <th width="100px" className="text-center">
                    Quantity
                  </th>
                  <th width="200px" className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.inventories.length > 0 ? (
                  this.state.inventories.map((inventory, idx) => {
                    return (
                      <tr key={idx}>
                        <td className="text-center">{idx + 1}</td>
                        <td>
                          {inventory.itemName}{" "}
                          <strong>[ {inventory.itemCode} ]</strong>
                        </td>
                        <td className="text-center">
                          {inventory.feeCategoryId}
                        </td>
                        <td>{inventory.description}</td>
                        <td className="text-left">
                          <strong>Purchase Price: </strong>
                          Rs. {inventory.purchasePrice}
                          <br />
                          <strong>Selling Price: </strong>
                          Rs. {inventory.sellingPrice}
                          <br />
                          <strong>Reorder Level: </strong>
                          {inventory.reorderLevel}
                        </td>
                        <td className="text-center">
                          {inventory.editQuantity ? (
                            <input
                              type="number"
                              className="form-control"
                              name="quantity"
                              value={this.state.quantity}
                              onChange={this.handleChange}
                              onKeyDown={(e) => {
                                // Prevent the user from entering negative values using keyboard input
                                if (e.key === "-" || e.key === "-") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          ) : inventory.inventoryItemStockLevels.length > 0 ? (
                            //Add numbers inside array of object
                            // inventory.inventoryItemStockLevels
                            //   .map((item) => item.quantity)
                            //   .reduce(
                            //     (prev, next) => parseInt(prev) + parseInt(next)
                            //   )
                            inventory.instock
                          ) : (
                            0
                          )}
                        </td>
                        <td className="text-center">
                          {inventory.editQuantity ? (
                            <>
                              <button
                                className="tt-button tt-button-primary"
                                onClick={() =>
                                  this.submitQuantity(inventory.id)
                                }
                              >
                                Save
                              </button>
                              <button
                                className="tt-button tt-button-danger ml-2"
                                onClick={() =>
                                  this.handleChangeEditQuantity(idx, false)
                                }
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="tt-button tt-button-primary"
                                onClick={() =>
                                  this.handleChangeEditQuantity(idx, true)
                                }
                              >
                                Add Quantity
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      {this.state.loader ? (
                        <>
                          <Spinner color="primary"></Spinner>
                          <br />
                          Loading ...
                        </>
                      ) : (
                        "No items added"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* {this.state.inventories.length > 0 ? <div></div> : <div>No data</div>} */}
        <ModalWindow
          modal={this.state.addModal}
          toggleModal={this.handleAddModal}
          modalHeader={"Add Inventory Items"}
          size="xl"
          modalBody={
            <InventoryItemForm
              toggleModal={this.handleAddModal}
              getInventories={this.getInventories}
              categories={this.state.categories}
            ></InventoryItemForm>
          }
        ></ModalWindow>

        <ModalWindow
          modal={this.state.permissionModal}
          size="lg"
          id="tt-permissionModal"
          toggleModal={() => {
            this.setState({
              permissionModal: !this.state.permissionModal,
            });
          }}
          modalHeader={"Assign permission to user"}
          modalBody={
            <GranularPermissionModal
              widgetName="Account"
              moduleName="Inventory"
              header="Add Inventory Items"
              activityName="inventory-items"
            />
          }
        ></ModalWindow>
      </div>
    );
  }
}

export default InventoryItems;
